function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#5173f3",
    r: 256,
    "data-original": "#ffb54a",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m341.163 497.473c78.312-27.62 139.156-92.243 161.529-172.881l-208.302-208.302s-88.712 74.301-85.07 94.69l40.698 40.207-13.628 141.513z",
    fill: "#1d0df9",
    "data-original": "#f9880d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.39 116.29v276.41h-58v-205.06l-27.07 23.34-37.87-43.93 55.38-47.75 3.49-3.01z",
    fill: "#f8fffb",
    "data-original": "#f8fffb",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 116.29h38.39v276.41h-38.39z",
    fill: "#d8d8d8",
    "data-original": "#d8d8d8",
    style: {}
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.8ca7cff3e99f05f83b48d69370bfbaa9.svg";
export { ForwardRef as ReactComponent };